<div class="check-all">
    <mat-checkbox class="checkbox-select-all"
        color="accent"
        [indeterminate]="isIndeterminate()"
        [checked]="isChecked()" (click)="$event.stopPropagation()"
        (change)="toggleSelection($event)" multiple>
        {{'shared.components.selectCheckAll.shortLabel' | translate}}      
    </mat-checkbox>
</div>
